<template>
  <div class="wf-page-controls bg-white">
    <div class="container">
      <div class="wf-page-controls-items">
        <div class="wf-page-control-item wf-page-control-item-navigation-back">
          <div class="page-navigation-back-button">
            <button
              type="button"
              class="d-inline-flex btn btn-sm btn-light"
              onclick="history.back()"
              aria-label="Back"
              v-if="backUrl"
            >
              <span
                class="png-icon png-icon-icons-glyph--k-carrot-back-title d-inline d-lg-none"
              >
              </span>
              <span
                class="png-icon png-icon-icons-glyph--k-arrow-left-sm d-none d-lg-inline"
              >
              </span>
              <span class="d-none d-lg-inline pl-1">
                Return back to previous page
              </span>
            </button>
          </div>
        </div>
        <div class="wf-page-control-item wf-page-control-item-share-button">
          <div class="dropdown">
            <button
              class="btn btn-sm btn-light"
              type="button"
              id="share-page-dropdown-button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="mr-1">Share</span>
              <span class="png-icon png-icon-icons-glyph--k-share "> </span>
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="share-page-dropdown-button"
            >
              <!-- AddToAny BEGIN -->
              <div class="a2a_kit a2a_kit_size_40 a2a_default_style">
                <ul
                  class="list-unstyled d-flex flex-column align-items-center m-0"
                >
                  <li class="p-1">
                    <a class="a2a_button_twitter"></a>
                  </li>
                  <li class="p-1">
                    <a class="a2a_button_facebook"></a>
                  </li>
                  <li class="p-1">
                    <a class="a2a_button_linkedin"></a>
                  </li>
                  <li class="p-1">
                    <a class="a2a_button_pinterest"></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backUrl: false
    };
  },
  mounted() {
    this.backUrl = history.length > 1;

    let script = document.createElement('script');
    script.src = 'https://static.addtoany.com/menu/page.js';
    script.async = true;
    script.onload = this.initializeAddToAny();
    document.head.appendChild(script);
  },
  methods: {
    initializeAddToAny() {
      $('#share-page-dropdown-button').click(() => {
        $('.a2a_svg').css("background-color", "transparent");
        $('.a2a_svg path').attr("fill", "#000");
      })
    },
  },
};
</script>